export default __webpack_public_path__ + "static/media/Head_4_Ear_1_C1.2ce640fc.svg";